// import "./Event.css";

// const statusColors = {
//   running: "status-running",
//   new: "status-new",
//   old: "status-old",
//   upcoming: "status-upcoming"
// };

// const statusIcons = {
//   running: (
//     <svg className="status-icon" viewBox="0 0 20 20" fill="none" stroke="#fff" strokeWidth="2">
//       <circle cx="10" cy="10" r="8" />
//       <path d="M7 10l3 3 3-6"/>
//     </svg>
//   ),
//   new: (
//     <svg className="status-icon" viewBox="0 0 20 20" fill="#fff">
//       <circle cx="10" cy="10" r="8"/>
//     </svg>
//   ),
//   old: (
//     <svg className="status-icon" viewBox="0 0 20 20" fill="none" stroke="#fff" strokeWidth="2">
//       <circle cx="10" cy="10" r="8" />
//       <path d="M6 10l4 4 4-8"/>
//     </svg>
//   ),
//   upcoming: (
//     <svg className="status-icon" viewBox="0 0 20 20" fill="none" stroke="#222" strokeWidth="2">
//       <circle cx="10" cy="10" r="8" />
//       <path d="M10 5v5l3 3"/>
//     </svg>
//   )
// };
// export default function EventCard({ event }) {
//   const getStatusClass = (status) => {
//     switch (status) {
//       case "running": return "event-status-ongoing";
//       case "old": return "event-status-old";
//       case "upcoming": return "event-status-upcoming";
//       default: return "";
//     }
//   };

//   return (
//     <div className="event-card">
//       <div className="event-image-wrapper">
//         <img src={event.image} alt={event.title} className="event-image" />
//         <div className="event-date-badge">
//           <div>{new Date(event.start).getDate()}</div>
//           <div>{new Date(event.start).toLocaleString('default', { month: 'short' }).toUpperCase()}</div>
//         </div>
//         {event.registered && (
//           <div className="event-registered">Registered ✅</div>
//         )}
//       </div>
//       <div className="event-content">
//         <div className="event-title">{event.title}</div>
//         <div className="event-meta">
//           <span>🕒 {event.start} - {event.end}</span>
//           <span>📍 {event.location}</span>
//         </div>
//         <div className={`event-tag ${getStatusClass(event.status)}`}>
//           {event.status === "running"
//             ? "Ongoing"
//             : event.status === "old"
//             ? "Completed"
//             : "Upcoming"}
//         </div>
//         <a className="event-link-button" href={event.link} target="_blank" rel="noopener noreferrer">
//           View Event →
//         </a>
//       </div>
//     </div>
//   );
// }

"use client"

import { Calendar, MapPin, CheckCircle, ArrowRight } from "lucide-react"
import { format } from "date-fns"
import { useState } from "react"
import { motion } from "framer-motion"
import "./Event.css"

const EventCard = ({ event }) => {
  const [isHovered, setIsHovered] = useState(false)

  const formattedStartDate = event.start ? format(new Date(event.start), "MMM dd, yyyy hh:mm a") : "N/A"
  const formattedEndDate = event.end ? format(new Date(event.end), "MMM dd, yyyy hh:mm a") : "N/A"

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    hover: { scale: 1.03, boxShadow: "0 20px 40px rgba(0, 0, 0, 0.4)" },
  }

  return (
    <motion.div
      className="event-card"
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      transition={{ duration: 0.3 }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="event-image-container">
        <img
          src={event.image || "/placeholder.svg?height=200&width=300&query=event"}
          alt={event.title}
          className="event-image"
        />
        <div className="event-status-badge">{event.status === "upcoming" ? "Upcoming" : "Past"}</div>
      </div>
      <div className="event-details">
        <h3 className="event-title">{event.title}</h3>
        <div className="event-meta">
          <div className="event-meta-item">
            <Calendar size={16} className="event-icon" />
            <span>{formattedStartDate}</span>
          </div>
          <div className="event-meta-item">
            <MapPin size={16} className="event-icon" />
            <span>{event.location}</span>
          </div>
        </div>
        <div className="event-actions">
          {event.registered && (
            <div className="event-registered-badge">
              <CheckCircle size={16} /> Registered
            </div>
          )}
          <a href={event.link} target="_blank" rel="noopener noreferrer" className="view-details-button">
            View Details
            <ArrowRight size={16} className="ml-2" />
          </a>
        </div>
      </div>
    </motion.div>
  )
}

export default EventCard
